import React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

//LocalS
import VenueItem from "./VenueItem";
import OverlaySpinner from "../.././Shared/OverlaySpinner";

// Material UI
import { withStyles } from "material-ui/styles";
import Grid from "material-ui/Grid";
import GeoLocation from ".././Location/Geolocation";

const styles = {
  root: {
    width: "100%",
    flexGrow: 1
  }
};

const ordertimes = starttime => {};

class City extends React.Component {
  state = {
    mylocation: null
  };

  mylocation = data => {
    this.setState({ mylocation: data });
  };

  render() {
    if (this.props.allVenuesQuery.loading) {
      return <OverlaySpinner />;
    }
    const list = this.props.allVenuesQuery.allVenues;
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <GeoLocation mylocation={this.mylocation} />
        <Grid
          container
          style={{
            margin: 0,
            width: "100%"
          }}
        >
          {list.map(item => {
            return (
              <Grid item xs sm key={item.id}>
                <VenueItem
                  ordertimes={ordertimes}
                  item={item}
                  mylocation={this.state.mylocation}
                />
              </Grid>
            );
          })}
        </Grid>
      </div>
    );
  }
}

const ALL_VENUES_QUERY = gql`
  query {
    allVenues(
      orderBy: updatedAt_DESC
      filter: { cities_some: { cityName: "Walnut Creek" } }
    ) {
      id
      geolocation
      address
      venueName
      venueDescription
      venueGallery
      avatarUrl
      zip
      updatedAt
      menus {
        id
        menuName
        info
        menuTimes {
          id
          startTime
          endTime
          daysOfWeek
          daysOfMonth
          daysOfYear
          daysOfMonth
          monthsOfYear
        }
        items {
          id
          itemName
          happyPrice
          normalPrice
          itemType
          itemDiscount
        }
      }
    }
  }
`;

const CityWithStyles = withStyles(styles)(City);

export default graphql(ALL_VENUES_QUERY, { name: "allVenuesQuery" })(
  CityWithStyles
);



// WEBPACK FOOTER //
// ./src/Features/City/index.js